import React from 'react'
import { CloseSquare, RefreshSquare, TimerStart } from 'iconsax-react'

import Button from '../Button2'
import Tooltip from '../Tooltip'

import { track } from '@SonarCX/lib/mixpanel'
import useStyles from './styles'

interface RefreshAlertProps {
  onClose: (e: React.SyntheticEvent) => void
}

const RefreshAlert: React.FC<RefreshAlertProps> = ({ onClose }) => {
  const classes = useStyles()

  const HandleRefreshClick = React.useCallback(() => {
    track('UPDATE_PROMPT_REFRESH')
    localStorage.removeItem('version')
    window.location.reload()
  }, [])

  return (
    <div className={classes.root}>
      <div>
        <img
          src='/imgs/sidenavV2logo.png'
          alt='SonarCX logo'
          className={classes.img}
        />
      </div>
      <div className={classes.textContainer}>
        <label className={classes.mainLabel}>SonarCX has been upgraded.</label>
        <label>Refresh to make it yours</label>
        <span className={classes.actionsContainer}>
          <Button className={classes.btnRoot} onClick={HandleRefreshClick}>
            <RefreshSquare className={classes.refreshIcon} />
            Refresh
          </Button>
          <Tooltip arrow title='Remind me later (In 2 hours)'>
            <Button className={classes.btnRoot} onClick={onClose}>
              <TimerStart className={classes.refreshIcon} />
              Remind me later
            </Button>
          </Tooltip>
        </span>
      </div>
      <Tooltip arrow title='Remind me later (In 2 hours)'>
        <CloseSquare className={classes.closeIcon} onClick={onClose} />
      </Tooltip>
    </div>
  )
}
export default RefreshAlert
